<template>
	<div>
		<div class="container">
			<nav aria-label="breadcrumb">
				<ol class="breadcrumb">
					<router-link :to="{ name: 'PCReDive'}" tag="li" class="breadcrumb-item">
						<a href="#">首頁</a>
					</router-link>
					<router-link :to="{ name: 'Other'}" tag="li" class="breadcrumb-item">
						<a href="#">其他資訊</a>
					</router-link>
					<li class="breadcrumb-item">
						女神的秘石所需表
					</li>
				</ol>
			</nav>
			<div class="item-box mb-4">
				<h3 class="item-title">
					簡易女神石計算機
				</h3>
				<div class="form-row">
					<div class="form-group col-12 col-md-4">
						<label for="inputState">升星 {{upStar-1}}→{{upStar}}</label>
						<select id="inputState" class="form-control" v-model="upStar" @change="change">
							<option>2</option>
							<option>3</option>
							<option selected>4</option>
							<option>5</option>
						</select>
					</div>
					<div class="form-group col-12 col-md-4">
						<label for="inputState">現在有的記憶碎片</label>
						<input type="number" class="form-control" v-model="nowHave" @change="change">
					</div>
					<div class="form-group col-12 col-md-4">
						<label for="inputState">花費的女神石</label>
						<select id="inputState" class="form-control" v-model="spend" @change="change">
							<option selected>1</option>
							<option>2</option>
							<option>3</option>
							<option>4</option>
							<option>5</option>
						</select>
					</div>
				</div>
				需要的女神的秘石為 <span class="badge badge-success px-4 py-2 mx-2" style="font-size: 18px">{{total}}</span> (皆以最大值計算)
			</div>
			<div class="item-box mb-4">
				<h3 class="item-title">
					簡易專武女神石計算機
				</h3>
				<div class="form-row">
					<div class="form-group col-12 col-md-6">
						<label for="inputState">當前等級</label>
						<select id="inputState" class="form-control" v-model="uq.uqCurrent" @change="changeUq">
							<option selected="selected" value="0">無專武</option>
							<option value="30">30</option>
							<option value="50">50</option>
							<option value="70">70</option>
							<option value="90">90</option>
							<option value="110">110</option>
							<option value="130">130</option>
							<option value="140">140</option>
							<option value="150">150</option>
							<option value="160">160</option>
							<option value="170">170</option>
							<option value="180">180</option>
							<option value="190">190</option>
							<option value="200">200</option>
							<option value="210">210</option>
							<option value="220">220</option>
							<option value="230">230</option>
							<option value="240">240</option>
							<option value="250">250</option>
							<option value="260">260</option>
							<option value="270">270</option>
							<option value="280">280</option>							
						</select>
					</div>
					<div class="form-group col-12 col-md-6">
						<label for="inputState">目標等級</label>
						<select id="inputState" class="form-control" v-model="uq.uqTarget" @change="changeUq">
							<option value="30">30</option>
							<option value="50">50</option>
							<option value="70">70</option>
							<option value="90">90</option>
							<option value="110">110</option>
							<option value="130">130</option>
							<option value="140">140</option>
							<option value="150">150</option>
							<option value="160">160</option>
							<option value="170">170</option>
							<option value="180">180</option>
							<option value="190">190</option>
							<option value="200">200</option>
							<option value="210">210</option>
							<option value="220">220</option>
							<option value="230">230</option>
							<option value="240">240</option>
							<option value="250">250</option>
							<option value="260">260</option>
							<option value="270">270</option>
							<option value="280">280</option>							
						</select>
					</div>
					<div class="form-group col-12 col-md-6">
						<label for="inputState">現在有的記憶碎片</label>
						<input type="number" class="form-control" v-model="uq.nowHave" @change="changeUq">
					</div>
					<div class="form-group col-12 col-md-6">
						<label for="inputState">花費的女神石</label>
						<select id="inputState" class="form-control" v-model="uq.spend" @change="changeUq">
							<option selected>1</option>
							<option>2</option>
							<option>3</option>
							<option>4</option>
							<option>5</option>
						</select>
					</div>
				</div>
				需要的女神的秘石為 <span class="badge badge-success px-4 py-2 mx-2" style="font-size: 18px">{{uq.total}}</span> (皆以最大值計算)
			</div>
			<div class="item-box">
				<h3 class="item-title">
					女神的秘石所需表
				</h3>
				<table class="table table-bordered table-hover">
					<thead>
						<tr>
							<th>購入數量</th>
							<th>需要的女神石數</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td>1~20</td>
							<td>1個</td>
						</tr>
						<tr>
							<td>21~40</td>
							<td>2個</td>
						</tr>
						<tr>
							<td>41~60</td>
							<td>3個</td>
						</tr>
						<tr>
							<td>61~80</td>
							<td>4個</td>
						</tr>
						<tr>
							<td>81~</td>
							<td>5個</td>
						</tr>
					</tbody>
				</table>
				<h3 class="item-title mt-4">
					開花所需的女神的秘石
				</h3>
				<table class="table table-bordered table-hover">
					<thead>
						<tr>
							<th>稀有度</th>
							<th>需要的記憶碎片</th>
							<th>「女神的秘石」合計需要的數量</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td>星1→2</td>
							<td>30</td>
							<td>40</td>
						</tr>
						<tr>
							<td>星1→3</td>
							<td>130</td>
							<td>450</td>
						</tr>
						<tr>
							<td>星1→4</td>
							<td>250</td>
							<td>1050</td>
						</tr>
						<tr>
							<td>星1→5</td>
							<td>400</td>
							<td>1800</td>
						</tr>
						<tr>
							<td>星2→3</td>
							<td>100</td>
							<td>300</td>
						</tr>
						<tr>
							<td>星2→4</td>
							<td>220</td>
							<td>900</td>
						</tr>
						<tr>
							<td>星2→5</td>
							<td>370</td>
							<td>1650</td>
						</tr>
						<tr>
							<td>星3→4</td>
							<td>120</td>
							<td>400</td>
						</tr>
						<tr>
							<td>星4→5</td>
							<td>150</td>
							<td>550</td>
						</tr>
						<tr>
							<td>星3→5</td>
							<td>270</td>
							<td>1150</td>
						</tr>
						<tr>
							<td>星3→4 <br>(精選轉蛋100碎片)</td>
							<td>20</td>
							<td>20</td>
						</tr>
						<tr>
							<td>星3→5 <br>(精選轉蛋100碎片)</td>
							<td>170</td>
							<td>650</td>
						</tr>
						<tr>
							<td>星3→4 <br>(精選轉蛋200碎片)</td>
							<td>0</td>
							<td>0</td>
						</tr>
						<tr>
							<td>星3→5 <br>(精選轉蛋200碎片)</td>
							<td>70</td>
							<td>200</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>
<script>
import UqLevel from "../../assets/edata/uqLevel.json";
export default {
	name: 'Megami',
	data() {
		return {
			upStar: 4,
			nowHave: 0,
			spend: 1,
			maxMemo: 120,
			total: 0,
			noShow: false,
			uq: {
				uqCurrent: 0,
				uqTarget: 280,
				nowHave: 0,
				spend: 1,
				maxLv: 280,
				total: 0
			}
		}
	},
	metaInfo: {
		// if no subcomponents specify a metaInfo.title, this title will be used
		title: '女神的秘石所需表',
		// all titles will be injected into this template
		titleTemplate: '%s | 蘭德索爾圖書館 公主連結 Wiki',
		meta: [
			{ name: 'description', content: "超異域公主連結☆Re:Dive 的女神的秘石所需表" }
		]
	},
	created: function() {},
	methods: {
		change: function() {
			var self = this;
			switch (self.upStar) {
				case "2":
					self.maxMemo = 30
					break;
				case "3":
					self.maxMemo = 100
					break;
				case "4":
					self.maxMemo = 120
					break;
				case "5":
					self.maxMemo = 150
					break;
				default:
			}
			var lacking = self.maxMemo - self.nowHave;
			var x = lacking;
			var ans = 0;
			var count = Number(self.spend);
			for (var i = 1; i <= x; i++) {
				ans += count;
				if (i % 20 == 0 && i <= 80) {
					if (count < 5) {
						count++;
					}
				}
			}

			self.total = ans;

		},
		changeUq: function() {
			var self = this;
			var current = Number(this.uq.uqCurrent);
			var target = Number(this.uq.uqTarget);
			var uqLevel = UqLevel;
			var filterUqLevel = _.filter(uqLevel,function(o){
				return o.uqLevel < target && o.uqLevel >= current ;
			})
			var memoSum = _.sumBy(filterUqLevel, 'memo');
			if (current == target) {
				memoSum = 0
			}
			var lacking = memoSum - self.uq.nowHave;
			var x = lacking;
			var ans = 0;
			var count = Number(self.uq.spend);
			for (var i = 1; i <= x; i++) {
				ans += count;
				if (i % 20 == 0 && i <= 80) {
					if (count < 5) {
						count++;
					}
				}
			}

			self.uq.total = ans;

		},
	},
	computed: {
		qq: function() {

		}
	},
	mounted: function() {
		this.change();
		this.changeUq();
	}
}
</script>
<style scoped>
</style>
